import axios from 'axios';

export const API_BASE_URL = '/api/v2';

export default () => axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND_URL}/api/v2`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('APIKey')}`,
  },
});
